/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export enum State {
  Invalid,
  Valid,
  ValidZero,
}

export enum Category {
  Done = 'done',
  Todo = 'todo',
  Upcoming = 'upcoming',
}

export enum ObjectType {
  Assessment = 'assessment',
  Request = 'request',
  Task = 'task',
}
